import { API_BASE_URL } from "../constants/Constants";
import { APIs } from "../constants/Constants";
import axiosInterceptor from "../helpers/Interceptor";

export const connectionToProvider = async (body, connectToProvider) => {
  let URL = connectToProvider ? APIs.CONNECTTOPROVIDER : APIs.CONNECTTOCLIENT;
  try {
    const response = await axiosInterceptor.post(API_BASE_URL + URL, {
      data: body,
    });
    console.log(response);
    return response;
  } catch (error) {
    if (error.response.status === 403)
      window.location.assign(APIs.REDIRECTLOGOUT);
    else return error.response;
  }
};
